
    // this file was auto generated by python script
    import PlusSquare from './PlusSquare';
    export default PlusSquare;
    